/**
 * 项目管理
 */
const ProjectRouter = {
  path: '/project',
  component: () => import('@/views/layout'),
  redirect: '/project/manage/list',
  alwaysShow: true,
  meta: {
    title: '项目管理',
    icon: require('@/assets/slider/project.png')
  },
  children: [
    // {
    //   path: 'position/list',
    //   name: 'project_position',
    //   component: () => import('@/views/project_manage/project_position.vue'),
    //   meta: {
    //     title: '项目位置'
    //   }
    // },
    // {
    //   path: 'team/list',
    //   name: 'team_list',
    //   component: () => import('@/views/team_list'),
    //   meta: {
    //     title: '队员列表'
    //   }
    // },

    // {
    //   path: 'type',
    //   name: 'all_project',
    //   component: () => import('@/views/all_project'),
    //   redirect: "type/CB/list",
    //   alwaysShow: true,
    //   meta: {
    //     title: '项目列表'
    //   },
    //   children: [
    //     {
    //       path: 'CB/list',
    //       name: 'CB',

    //       meta: {
    //         title: '长保项目'
    //       }
    //     },
    //   ]
    // },

    {
      path: 'approval/list',
      name: 'approval',
      component: () => import('@/views/approval/components/CB'),
      meta: {
        title: '立项',
        keepAlive: true
      }
    },
    {
      path: 'peocess/list',
      name: 'project_position',
      component: () => import('@/views/process_pages'),
      meta: {
        title: '进程',
        keepAlive: true
      }
    },
    {
      path: 'costaccount/list',
      name: 'cost_account',
      component: () => import('@/views/cost_accounting'),
      meta: {
        title: '成本核算',
        keepAlive: true
      }
    },
    {
      path: 'dispatch/list',
      name: 'dispatch_order',
      component: () => import('@/views/dispatch_order'),
      meta: {
        title: '派遣单',
        keepAlive: true
      }
    },
    {
      path: 'manage/list',
      name: 'team_list',
      component: () => import('@/views/all_project/CB'),
      meta: {
        title: '项目列表',
        keepAlive: true
      }
    },
    {
      path: 'check/list',
      name: 'check_time',
      component: () => import('@/views/check_time'),
      meta: {
        title: '考勤',
        keepAlive: true
      }
    }, {
      path: 'patrol/list',
      name: 'patrol_list',
      component: () => import('@/views/patrol'),
      meta: {
        title: '巡逻打卡',
        keepAlive: true
      }
    }, {
      path: 'praise/list',
      name: 'praise_list',
      component: () => import('@/views/isPraise'),
      meta: {
        title: '表扬投诉',
        keepAlive: true
      }
    }

  ]
}

export default ProjectRouter
